export default "__VITE_ASSET__CmFAIEEc__"